/* esm.sh - qr.js@0.0.0/lib/QRCode */
export * from "/*qr.js@0.0.0/esnext/lib/QRCode.mjs";
export { default } from "/*qr.js@0.0.0/esnext/lib/QRCode.mjs";
